import "../AboutUs/AboutUs.css";
import "./privacypolicy.css";
const PrivacyPolicy = () => {
  return (
    <section className="">
      <img
        alt=""
        src="/assets/images/privacypolicy-bg.png"
        className="privacy-policy-bg"
      ></img>
      <div className="container mx-auto">
        <div className="mt-3">
          <div className="text-center">
            <div className=" style1">Privacy Policy</div>
            <div className="mt-2 style2 mb-3">
              Connecting Diversity for a Decentralized Tomorrow.
            </div>
          </div>
          <div className="privacy-point-style mb-3">
            {/* ..................................About Us -1 ......................... */}

            <div>
              <ul>
                <p className="title-style">1. Introduction</p>
                <p>
                  Welcome to Zecurechain, a SaaS product developed by Unitic. At
                  Zecurechain, we value your privacy and are committed to
                  protecting your personal information. This Privacy Policy
                  explains how we collect, use, disclose, and safeguard your
                  data when you use our services.
                </p>
              </ul>
            </div>
            <div>
              <ul>
                <p className="title-style">2. Information We Collect</p>
                <p>
                  We collect and process the following types of information:
                </p>
                <p>
                  a. Personal Information: When you sign up for Zecurechain, we
                  collect information such as your name, email address, and
                  other information you provide during the registration process.
                </p>
                <p>
                  b. Usage Data: We may collect information about how you use
                  Zecurechain, including your interactions with the platform,
                  features you use, and the content you access.
                </p>
                <p>
                  c. Payment Information: When you subscribe to our services, we
                  collect payment information, such as credit card details, to
                  process your payments securely.
                </p>
                <p>
                  d. Cookies and Tracking Technologies: We may use cookies and
                  similar tracking technologies to enhance your experience and
                  collect information about your usage patterns on our website.
                </p>
              </ul>
            </div>
            <div>
              <ul>
                <p className="title-style">3. How We Use Your Information</p>
                <p>We use your information for the following purposes:</p>
                <p>
                  a. Providing Services: We use your personal information to
                  provide and maintain Zecurechain's services, including
                  creating and issuing digital certificates and storing
                  documents on the blockchain.
                </p>
                <p>
                  b. Communication: We may send you transactional emails,
                  updates, and information related to your account.
                </p>
                <p>
                  c. Payment Processing: We use your payment information to
                  process subscription payments.
                </p>
                <p>
                  d. Analytics: We collect usage data to analyze and improve the
                  performance and features of our services.
                </p>
                <p>
                  e. Legal Compliance: We may use your data to comply with legal
                  obligations and enforce our Terms of Service.
                </p>
              </ul>
            </div>
            <div>
              <ul>
                <p className="title-style">4. Data Security</p>
                <p>
                  We take data security seriously and employ industry-standard
                  security measures to protect your data. However, no method of
                  data transmission over the internet is completely secure, and
                  we cannot guarantee the absolute security of your data.
                </p>
              </ul>
            </div>
            <div>
              <ul>
                <p className="title-style">5. Disclosure of Your Information</p>
                <p>We may disclose your information to:</p>
                <p>
                  a. Service Providers: We may share your data with third-party
                  service providers who assist us in delivering our services.
                </p>
                <p>
                  b. Legal Requirements: We may disclose your information when
                  required by law, such as in response to a subpoena or other
                  legal process.
                </p>
              </ul>
            </div>

            <div>
              <ul>
                <p className="title-style">6. Your Choices</p>
                <p>
                  You can manage your account settings and preferences by
                  logging into your Zecurechain account. You may also contact us
                  to exercise your rights regarding your personal data,
                  including access, correction, deletion, or data portability.
                </p>
              </ul>
            </div>
            <div>
              <ul>
                <p className="title-style">7. Children's Privacy</p>
                <p>
                  Zecurechain is not intended for children under the age of 13,
                  and we do not knowingly collect personal information from
                  minors.
                </p>
              </ul>
            </div>

            <div>
              <ul>
                <p className="title-style">8. Changes to this Privacy Policy</p>
                <p>
                  We may update this Privacy Policy from time to time to reflect
                  changes in our practices or for other operational, legal, or
                  regulatory reasons. We will notify you of any material changes
                  by posting the updated Privacy Policy on our website.
                </p>
              </ul>
            </div>
            <div>
              <ul>
                <p className="title-style">9. Contact Us</p>
                <p>
                  If you have any questions, concerns, or requests regarding
                  this Privacy Policy or your personal information, please
                  contact us.
                </p>
              </ul>
            </div>
            <div>
              <ul>
                <p className="title-style">10. International Data Transfers</p>
                <p>
                  Your data may be processed and stored in countries outside of
                  your home country, including the United States, where data
                  protection laws may differ from those in your jurisdiction. By
                  using Zecurechain, you consent to the transfer of your data to
                  these countries.
                </p>
              </ul>
            </div>
            <div>
              <ul>
                <p className="title-style">11. Data Retention</p>
                <p>
                  We will retain your personal information only for as long as
                  necessary for the purposes outlined in this Privacy Policy, or
                  as required by law. When we no longer need your data, we will
                  securely delete or anonymize it.
                </p>
              </ul>
            </div>
            <div>
              <ul>
                <p className="title-style">12. Third-Party Links and Services</p>
                <p>
                  Zecurechain may contain links to third-party websites or
                  services. We are not responsible for the privacy practices or
                  content of these third-party websites. Please review the
                  privacy policies of these websites before providing them with
                  any personal information.
                </p>
              </ul>
            </div>
            <div>
              <ul>
                <p className="title-style">13. Marketing and Promotional Communications</p>
                <p>
                  We may use your email address to send you marketing
                  communications and promotional offers. You can opt-out of
                  receiving these communications by following the unsubscribe
                  instructions provided in the emails or by contacting us
                  directly.
                </p>
              </ul>
            </div>
            <div>
              <ul>
                <p className="title-style">14. Cookies and Tracking</p>
                <p>
                  We use cookies and similar tracking technologies to collect
                  information about your browsing behavior on Zecurechain. You
                  can manage your cookie preferences through your browser
                  settings.
                </p>
              </ul>
            </div>
            <div>
              <ul>
                <p className="title-style">15. Do Not Track Signals</p>
                <p>
                  Zecurechain does not respond to "Do Not Track" signals from
                  web browsers. We may still collect information about your
                  website visits, even if you have set your browser to send a
                  "Do Not Track" signal.
                </p>
              </ul>
            </div>
            <div>
              <ul>
                <p className="title-style">16. User Generated Content</p>
                <p>
                  If you post content on Zecurechain, such as reviews or
                  comments, please be aware that this information may be
                  publicly visible. We are not responsible for the privacy of
                  any information you choose to submit.
                </p>
              </ul>
            </div>
            <div>
              <ul>
                <p className="title-style">17. Business Transfers</p>
                <p>
                  In the event of a merger, acquisition, sale of assets, or
                  bankruptcy, your personal information may be transferred to
                  another entity. We will notify you in advance or as required
                  by law.
                </p>
              </ul>
            </div>
            <div>
              <ul>
                <p className="title-style">18. Consent</p>
                <p>
                  By using Zecurechain, you consent to the collection, use, and
                  disclosure of your information as described in this Privacy
                  Policy.
                </p>
              </ul>
            </div>
            <div>
              <ul>
                <p className="title-style">19. Contact Information</p>
                <p>
                  If you have any questions, concerns, or requests regarding
                  this Privacy Policy or your personal information, please
                  contact us at [Contact Information].
                </p>
              </ul>
            </div>
            <div>
              <ul>
                <p className="title-style">20. Complaints</p>
                <p>
                  If you believe that your privacy rights have been violated,
                  you have the right to lodge a complaint with the appropriate
                  data protection authority in your jurisdiction.
                </p>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default PrivacyPolicy;
